'use client';
import classNames from 'classnames';
import { isH5HandleClient } from 'eco-design-micro/utils-base/isH5Handle';
import getLocal from 'eco-design-reliance/getLocal';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import EcoLink from 'eco-design/base/eco-link';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import LocaleIcon from './LocaleIcon';

const EFRegion: any = dynamic(() => import('@/components/UI/EFRegion'), { ssr: false });

export default function GlobalLocaleV1({ className, label = '', title }: { className?: string; label?: string; title: string }) {
    const { locale } = getLocal();
    const [isOpenA, setIsOpenA] = useState(false);
    const [destroy, setDestroy] = useState(false);
    const [entryPosition, setEntryPosition] = useState('bottom function');
    const classes = classNames({
        [`${className}`]: className,
        [`glo-nav-locale-button`]: true,
    });
    // 打开
    const openHandleA = (e?: any) => {
        const isH5 = isH5HandleClient();
        if (isH5) return;
        if (e) {
            e.preventDefault();
        }
        setIsOpenA(true);
    };

    useEffect(() => {
        EcoDesignEventsBus.on('GlobalLocaleV1-region-open', (entryPosition='') => {
            setEntryPosition(entryPosition);
            openHandleA();
        });
    }, []);

    return (
        <>
            <EcoLink
                className={`glo-nav-locale-href GtmModuleData-btn-href`}
                aria-label="locale link"
                href={`/${locale}/region`}
                onClick={openHandleA}
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'change_country',
                    button_name: title,

                    __btn_id1: 'glo-nav-locale-href',
                    __btn_id2: `${locale}/region`,
                    __btn_type: 'href',
                }}
            >
                <LocaleIcon />
                <span>{title}</span>
            </EcoLink>

            {!destroy && isOpenA && <EFRegion visible={isOpenA} onClose={() => setIsOpenA(false)} onDestroy={() => setDestroy(true)} entryPosition={entryPosition} />}
        </>
    );
}
